export default "__VITE_ASSET__D2P8R8sY__"